// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import somos from "assets/images/somos.jpg"

function Somos() {

  return (
    <>
      <DefaultNavbar
        routes={routes}
        sticky
      />
      <MKBox minHeight="30vh"></MKBox>
      <Card
        minHeight="30vh"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" >
          <Container>
            <Grid
              container
              item
              flexDirection="column"
              alignItems="center"
              sx={{ textAlign: "justify", my: 6, mx: "auto", px: 0.75 }}
            >
              <MKTypography variant="h1" fontWeight="bold" color="#537aba" style={{textAlign: "center", marginBottom: "30px"}}>
                ¿Quienes somos?
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Somos ARES, una empresa dedicada a la comercialización de equipos de bombeo industrial. Nos especializamos en ofrecer soluciones con equipos de marcas reconocidas, así como opciones genéricas de calidad y alto desempeño.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                En ARES, nuestro objetivo diario es convertirnos en tu principal aliado en el suministro, mantenimiento, reparación y asesoría de sistemas de bombeo, abarcando distintas industrias y aplicaciones.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Contamos con una amplia variedad de equipos, incluyendo bombas de cebado y autocebado, de diafragma, sumergibles, de vacío, de anillo líquido, de pistón y de alta presión, entre otros.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                Además, ofrecemos una línea completa de refacciones y accesorios, lo que nos permite proporcionar soluciones integrales y adaptadas a las necesidades específicas de cada cliente.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                También brindamos servicios de aplicaciones especiales para sistemas de bombeo múltiple, de derivación y para puntos de difícil acceso, asegurando eficiencia en condiciones particulares.
              </MKTypography>
              <MKTypography variant="body1" color="text" style={{marginBottom: "20px"}}>
                En ARES, nos involucramos directamente en la resolución de los desafíos de nuestros clientes, destacando por nuestra calidad, atención personalizada y conocimiento técnico. No solo vendemos equipos de bombeo: trabajamos como socios estratégicos comprometidos con el éxito de tu operación.
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
            component="section"
            variant="gradient"
            bgColor="dark"
            position="relative"
            py={6}
            px={{ xs: 2, lg: 0 }}
            mx={-2}
        >
            <Container>
                <Grid container>
                    <Grid item xs={12} md={8} sx={{ mb: 3 }}>
                        <MKTypography variant="h3" color="white">
                            ESPECIALIDAD EN EQUIPO DE BOMBEO
                        </MKTypography>
                        <MKTypography variant="body2" color="white" opacity={0.8}>
                            Nuestra especialidad probada a través de los años son en los siguientes tipos de Bombas:
                        </MKTypography>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <MKBox mb={1}>
                            <MKTypography variant="body2" color="white" opacity={0.8}>
                                Bombas de Doble Diafragma (Bombas Neumáticas)
                            </MKTypography>
                            <MKTypography variant="body2" color="white" opacity={0.8}>
                                Bombas Centífrugas
                            </MKTypography>
                            <MKTypography variant="body2" color="white" opacity={0.8}>
                                Bombas de Vacío
                            </MKTypography>
                            <MKTypography variant="body2" color="white" opacity={0.8}>
                                Bombas de Vacío de Anillo Líquido
                            </MKTypography>
                            <MKTypography variant="body2" color="white" opacity={0.8}>
                                Bombas Dosificadoras
                            </MKTypography>
                            <MKTypography variant="body2" color="white" opacity={0.8}>
                                Bombas Tamboreras
                            </MKTypography>
                        </MKBox>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
        <MKBox component="section" py={{ xs: 0, lg: 6 }}>
            <Container>
                <Grid container item>
                <MKBox
                    width="100%"
                    bgColor="white"
                    borderRadius="xl"
                    shadow="xl"
                    mb={6}
                    sx={{ overflow: "hidden" }}
                >
                    <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        lg={5}
                        position="relative"
                        px={0}
                        sx={{
                        backgroundImage: ({
                            palette: { gradients },
                            functions: { rgba, linearGradient },
                        }) =>
                            `${linearGradient(
                            rgba(gradients.dark.main, 0.8),
                            rgba(gradients.dark.state, 0.8)
                            )}, url(${somos})`,
                        backgroundSize: "cover",
                        }}
                    >
                    </Grid>
                    <Grid item xs={12} lg={7}>
                        <MKBox component="form" p={2} method="post">
                            <MKBox px={3} py={{ xs: 2, sm: 6 }}>
                                <MKTypography variant="h2" mb={1}>
                                    Deja tu instalación y proyectos con expertos
                                </MKTypography>
                                <MKTypography variant="body1" color="text" mb={2}>
                                    Ofrecemos soluciones especializadas, con la marca que buscas y con marcas intercambiables a costos muy accesibles para tu industrial.
                                </MKTypography>
                                <MKTypography variant="body1" color="text" mb={2}>
                                    Manejamos garantía de 1 año contra defectos de fabricación en prácticamente todas las marcas y modelos de equipo de bombeo.
                                </MKTypography>
                                <MKTypography variant="body1" color="text" mb={2}>
                                    Además contamos con distribución y representación exclusiva de algunas de las mejores marcas en el mercado.
                                </MKTypography>
                                <MKTypography variant="body1" color="text" mb={2}>
                                    Nuestro equipo técnico, de ingeniería y de consultoría está para ayudarte en cada uno de los procesos de tu proyecto.
                                </MKTypography>
                                <MKTypography variant="body1" color="text" mb={2}>
                                    Entendemos que las necesidades cambian para cada cliente, pero las exigencias de la industria deben de ser las más altas del mercado. Por lo que desarrollamos soluciones únicas y especializadas.
                                </MKTypography>
                                <MKTypography variant="body1" color="text" mb={2}>
                                    Nuestro servicio y atención dedicada es un modelo post-venta.
                                </MKTypography>
                            </MKBox>
                        </MKBox>
                    </Grid>
                    </Grid>
                </MKBox>
                </Grid>
            </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Somos;
